export default __webpack_public_path__ + "static/review2-117faf6727bd7250b3d4b164b7514326.png";